module.exports = __webpack_public_path__ + "img/world.a171f42b.svg";